import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons'

function EntryProject(props) {
  return (
    <div className="column col-md-4 single-service">
    <div className="projects-container" style={{marginRight: "10px"}}>
      <div>
  		  <div className="item-service">
           <div>
              <img  className="project-image" src={props.image} alt="" />
           </div>
           <div className="item-service-content" style={{paddingLeft:"30px",paddingBottom:"20px"}}>
              <h5 style={{fontWeight:"bold"}}>{props.title}</h5>
              <div className="project-description">
              <a className="projectlinks projectlinks1" href={props.linkedinurl}><p><b>View </b><FontAwesomeIcon className="service-icons changeOn" icon={faArrowCircleRight} /></p></a>
              <a className="projectlinks projectlinks2" href={props.githuburl}><p><b>Github Repo </b><FontAwesomeIcon className="service-icons changeOn" icon={faArrowCircleRight} /></p></a>
              </div>
           </div>
        </div>
      </div>
  	</div>
    </div>
  );
}

export default EntryProject;
